module.exports = __webpack_public_path__ + "img/148a1d775e18e8014c729bc873a36db2.png";